module.exports = __webpack_public_path__ + "assets/img/8.51f0371b.png";